// React エラー境界。子ツリーの描画時例外を封じ込め、解析できるよう
// エラーメッセージとコンポーネントスタックを表示する。非同期・イベント内の
// 例外は境界では捕まらない (各コンポーネントが自前で扱う) 点に注意。
import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode; label?: string };
type State = { error: Error | null; stack: string | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, stack: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ stack: info.componentStack ?? null });
    // 解析用にコンソールへも残す
    console.error('ErrorBoundary', this.props.label ?? '', error, info.componentStack);
  }

  render() {
    const { error, stack } = this.state;
    if (error) {
      return (
        <div className="error-boundary" role="alert">
          <strong>表示に失敗しました{this.props.label ? `: ${this.props.label}` : ''}</strong>
          <pre>
            {error.message}
            {stack ? `\n${stack}` : ''}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
